<template>
  <div>
    <template v-if="display==1">
      <h5>ユーザ管理<span></h5>
      <label for="status" class="col-form-label">種別:</label>
      <select class="my-2" v-model="searchForm.user_type">
        <option v-for="(item, index) in user_type" :value="item.no" :key="`status-${item.no}`">{{ item.name }}</option>
      </select>
      <template v-if="String(searchForm.user_type) == '2'">
        <label for="status" class="col-form-label">本人確認ステータス:</label>
        <select class="my-2" v-model="searchForm.identification_flg">
          <option v-for="(item, index) in identification_flg" :value="item.no" :key="`status-${item.no}`">{{ item.name }}</option>
        </select>
      </template>
      <a class="btn btn-info col-md-1 my-2" href="javascript:void(0);" @click="searchUser">検索</a>
      <hr>
      <div class="py-3 product_contents">
        <div v-for="(user, index) in allGetUsers">
          <div class="card col-md-12 pl-0 pr-0 m-0 mb-2">
              <div class="card-header">
                  <div class="row">
                      <span class="col-md-12 text-right">
                        <a href="javascript:void(0);" @click="messageUser(user['id'])" class="btn btn-primary btn-sm">メッセージ</a>
                        <a href="javascript:void(0);" @click="detailUserLink(user['id'])" class="btn btn-primary btn-sm">詳細</a>
                      </span>
                  </div>
              </div>
              <div class="card-body">
                  <div class="row px-3">
                      <div class="col-md-3 pl-1 pr-1 m-0">
                        <img class="" :src="user['image1']" style="width: 100%;height: auto;">
                      </div>
                      <div class="card col-md-9 pl-0 pr-0 m-0">
                          <div class="card-body">
                              <p class="card-text">名前:　
                                <span v-if="user['user_type'] == 2">
                                  <strong v-if="user['legal_person']==1">{{ cinit(user['corp_name'], '-') }}</strong>
                                  <strong v-else-if="user['legal_person']==0">{{ cinit(user['store_name'], '-') }}</strong>
                                </span>
                                <span>{{ getUserName(user) }}</span>
                              </p>
                              <p class="card-text">種別:　{{ get_hash_value(user_type, user['user_type']) }}</p>
                              <p class="card-text">ステータス:　{{ get_hash_value(del_flg, user['del_flg']) }}</p>
                              <p class="card-text" v-if="user['user_type'] == 2">本人確認:　{{ get_hash_value(identification_flg, user['identification_flg']) }}</p>
                              <p class="card-text">登録日:　{{ date_only_format(user['created_at']) }}</p>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
        </div>
        <div class="page" v-show="all_users.length>0">
          <vuejs-paginate
            :page-count="allGetPageCount"
            :page-range="3"
            :margin-pages="2"
            :click-handler="allClickCallback"
            :prev-text="'＜'"
            :next-text="'＞'"
            :container-class="'pagination'"
            :page-class="'page-item'">
          </vuejs-paginate>
        </div>
      </div>
    </template>

    <template v-if="display==2">
      <h5>ユーザ詳細</h5>
      <!--<a class="btn btn-info col-md-4" href="javascript:void(0);" @click="backUser">戻る</a>-->
      <hr>
      <template v-if="String(user_detail['identification_flg']) == '1' && String(user_detail['file_path1']) != ''">
        <a class="btn btn-info col-md-3 mb-3" href="javascript:void(0);" @click="fileDl(user_detail['file_path1'])">本人確認書類1 DL</a>
      </template>
      <template v-if="String(user_detail['identification_flg']) == '1' && String(user_detail['file_path2']) != ''">
        <a class="btn btn-info col-md-3 mb-3" href="javascript:void(0);" @click="fileDl(user_detail['file_path2'])">本人確認書類2 DL</a>
      </template>
      <template v-if="String(user_detail['identification_flg']) == '1'">
        <a class="btn btn-info col-md-3 mb-3" href="javascript:void(0);" @click="updIdentification(user_detail['id'], 3)">本人確認OK</a>
        <a class="btn btn-danger col-md-3 mb-3" href="javascript:void(0);" @click="updIdentification(user_detail['id'], 2)">本人確認NG</a>
      </template>
      <ul>
        <li class="row" v-for="(value, key) in user_detail">
          <template v-if="exchange_db_users(key, user_detail['user_type']) != ''">
            <template v-if="String(key)=='maintenance_policy'">
              <div class="mt-5 mb-3 col-12 text-center" style="font-size: 1.3rem;">販売共通情報</div>
            </template>
            <template v-if="String(key)=='user_type'">
              <span class="col-md-3 hed">{{ exchange_db_users(key, user_detail['user_type']) }}</span><span class="col-md-8 dat">{{ get_hash_value(user_type, value) }}</span>
            </template>
            <template v-else-if="String(key)=='del_flg'">
              <span class="col-md-3 hed">{{ exchange_db_users(key, user_detail['user_type']) }}</span><span class="col-md-8 dat">{{ get_hash_value(del_flg, value) }}</span>
            </template>
            <template v-else-if="String(key)=='identification_flg'">
              <span class="col-md-3 hed">{{ exchange_db_users(key, user_detail['user_type']) }}</span><span class="col-md-8 dat">{{ get_hash_value(identification_flg, value) }}</span>
            </template>
            <template v-else-if="String(key)=='identification_flg'">
              <span class="col-md-3 hed">{{ exchange_db_users(key, user_detail['user_type']) }}</span><span class="col-md-8 dat">{{ get_hash_value(identification_flg, value) }}</span>
            </template>
            <template v-else-if="String(key)=='legal_person'">
              <span class="col-md-3 hed">{{ exchange_db_users(key, user_detail['user_type']) }}</span><span class="col-md-8 dat">{{ get_hash_value(legal_person, value) }}</span>
            </template>
            <template v-else-if="String(key)=='gender'">
              <span class="col-md-3 hed">{{ exchange_db_users(key, user_detail['user_type']) }}</span><span class="col-md-8 dat">{{ get_hash_value(gender, value) }}</span>
            </template>
            <template v-else-if="String(key)=='about_areas_sell'">
              <span class="col-md-3 hed">{{ exchange_db_users(key, user_detail['user_type']) }}</span><span class="col-md-8 dat">{{ get_hash_value(about_areas_sell, value) }}</span>
            </template>
            <template v-else-if="String(key)=='test_bullet_required'">
              <span class="col-md-3 hed">{{ exchange_db_users(key, user_detail['user_type']) }}</span><span class="col-md-8 dat">{{ get_hash_value(require_or, value) }}</span>
            </template>
            <template v-else-if="String(key)=='about_test_bullet'||String(key)=='about_return'||String(key)=='about_exchange'||String(key)=='credit_payment'||String(key)=='whether_pay_installments'">
              <span class="col-md-3 hed">{{ exchange_db_users(key, user_detail['user_type']) }}</span><span class="col-md-8 dat">{{ get_hash_value(ok_or, value) }}</span>
            </template>
            <template v-else-if="String(key)=='deleted_at'||String(key)=='created_at'||String(key)=='updated_at'">
              <span class="col-md-3 hed">{{ exchange_db_users(key, user_detail['user_type']) }}</span><span class="col-md-8 dat">{{ convert_jst_for_message(value) }}</span>
            </template>
            <template v-else>
              <span class="col-md-3 hed">{{ exchange_db_users(key, user_detail['user_type']) }}</span><span class="col-md-8 dat">{{ value }}</span>
            </template>
          </template>
        </li>
      </ul>
    </template>

    <a id="download-link" v-bind:href="downloadUrl" v-bind:download="fileName">Link</a>

  </div>
</template>

<script>
import VueJsPaginate from "vuejs-paginate";
import axios from 'axios';

export default {
  components: {
    'vuejs-paginate': VueJsPaginate,
  },
  props: { 
    user: Object
  },
  data() {
		const legal_person = [
      {"no":"1","name":"法人"},
      {"no":"0","name":"個人"},
    ];
		const gender = [
      {"no":"1","name":"男"},
      {"no":"2","name":"女"},
    ];
		const user_type = [
      {"no":"","name":"全て"},
      {"no":"1","name":"一般"},
      {"no":"2","name":"販売者"},
      {"no":"3","name":"スタッフ"},
    ];
		const del_flg = [
      {"no":"0","name":"有効"},
      {"no":"1","name":"無効"},
    ];
		const identification_flg = [
      {"no":"0","name":"未完了"},
      {"no":"1","name":"申請中"},
      {"no":"2","name":"エラー"},
      {"no":"3","name":"完了"},
    ];
    const about_areas_sell = [
      {"no":"1","name":"営業エリアのみ"},
      {"no":"2","name":"全国通販可能"},
    ];
    const require_or = [
      {"no":"1","name":"必須"},
      {"no":"2","name":"必須ではない"},
    ];
    const ok_or = [
      {"no":"1","name":"可能"},
      {"no":"2","name":"不可能"},
    ];
    return {
      downloadUrl: null,
      fileName: '',
      legal_person,
      gender,
      user_type,
      del_flg,
      identification_flg,
      about_areas_sell,
      require_or,
      ok_or,
      display: 1,
			all_users: [],
      user_detail: null,
			all_parPage: 5,
			all_currentPage: 1,
      searchForm: {
        user_type: "",
        identification_flg: "1",
      },
      isError: false,
    }
  },
  methods: {
    searchUser() {
      this.get_users();
      return false;
    },
    backUser() {
      this.display = 1;
      return false;
    },
    detailUserLink(id) {
      window.open('/mypage?page=3&users_id='+id, '_blank')
      return false;
    },
    detailUser(id) {
      this.user_detail = null;
      this.get_user(id);
      this.display = 2;
    },
    messageUser(id) {
      // this.$router.push({path: '/message/'+String(id)+'/9/0'});
      window.open('/message/'+String(id)+'/9/0', '_blank')
    },
    // ユーザ更新処理
    async updIdentification(users_id, identification_flg) {
			this.$store.dispatch('user/upd_identification_flg', {
        users_id: users_id,
        identification_flg: identification_flg,
      }).then(res => {
				console.log(res);
				this.user_detail['identification_flg'] = identification_flg;
			}, error => {
				console.log('error発生');
				console.log(error);
				this.$nextTick(() => {
          window.scrollTo({
            top: 0,
          });
				});
			});
      return false;
    },
		async fileDl(path) {
      let stringArray = path.split('/');
      this.fileName = stringArray[stringArray.length -1];
      axios.post('/api/user/admin/download', {
        download_file: path,
      }, { responseType: 'blob' }).then(res => {
        let fileURL = window.URL.createObjectURL(new Blob([res.data]));
        this.downloadUrl = fileURL;
        setTimeout(() => {
          window.document.getElementById('download-link').click();
        }, 10);
      }).catch(error => {
        console.log('error発生');
        console.log(error);
				this.$nextTick(() => {
          window.scrollTo({
            top: 0,
          });
				});
      });
    },
		async get_users() {
			this.$store.dispatch('user/get_admin_users', {
        type: this.searchForm.user_type,
        identification_flg: this.searchForm.identification_flg,
      }).then(res => {
				console.log(res);
				this.all_users = res.data.users;
        if ( this.$route.query.users_id ) {
          this.detailUser(this.$route.query.users_id);
        }
			}, error => {
				console.log('error発生');
				console.log(error);
				this.$nextTick(() => {
          window.scrollTo({
            top: 0,
          });
				});
			});
		},
		async get_user(id) {
			this.$store.dispatch('user/get_admin_user', {
        id: id,
      }).then(res => {
				console.log(res);
        this.display = 2;
				this.user_detail = res.data.users;
			}, error => {
				console.log('error発生');
				console.log(error);
				this.$nextTick(() => {
          window.scrollTo({
            top: 0,
          });
				});
			});
		},
		allClickCallback: function (pageNum) {
      this.all_currentPage = Number(pageNum);
			this.$nextTick(() => {
				window.scrollTo({
					top: 0,
				});
			});
    },
  },
	computed: {
		allGetUsers: function() {
			let current = this.all_currentPage * this.all_parPage;
			let start = current - this.all_parPage;
			return this.all_users.slice(start, current);
		},
		allGetPageCount: function() {
			return Math.ceil(this.all_users.length / this.all_parPage);
		},
	},
  created() {
    this.get_users();
  },
}
</script>

<style>
.hed {
  padding: 4px;
  border: solid 1px #999393;
  margin-bottom: 4px;
  margin-right: 8px;
  display: inline-block;
  border-radius: 4px;
  background-color: #ebebeb;
}
.dat {
  padding: 4px;
  border: solid 1px #999393;
  margin-bottom: 4px;
  margin-right: 8px;
  display: inline-block;
  border-radius: 4px;
}
#download-link {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/mypage/admin/user.vue